export const ENDLESS_FIXED = '@/ENDLESS_FIXED';
export const ENDLESS_BASED_ON_CONTENT = '@/ENDLESS_BASED_ON_CONTENT';
